<script setup lang="ts">
const form = useForm<App.Data.Team.CreateTeamData>({
	method: 'POST',
	url: route('teams.store'),
	fields: {
		name: '',
		store_url: 'https://',
	},
	errorBag: 'createTeam',
})
</script>

<template>
	<base-dialog :title="t('app.create_new_team')">
		<ui-form @submit.prevent="form.submit">
			<ui-form-item>
				<ui-label for="name">
					{{ t('validation.attributes.name') }}
				</ui-label>
				<ui-input
					id="name"
					v-model="form.fields.name"
					required
					autofocus
				/>
				<ui-form-error :message="form.errors.name" />
			</ui-form-item>

			<ui-form-item>
				<ui-label for="store_url">
					{{ t('validation.attributes.store_url') }}
				</ui-label>
				<ui-input
					id="store_url"
					v-model="form.fields.store_url"
					required
					type="url"
				/>
				<ui-form-error :message="form.errors.store_url" />
			</ui-form-item>

			<ui-button type="submit" :loading="form.processing">
				{{ t('app.buttons.create') }}
				<template #icon>
					<i-ph-arrow-right />
				</template>
			</ui-button>
		</ui-form>
	</base-dialog>
</template>
